import * as $ from 'jquery';

UtilServiceAjs.$inject = [
  '$translate',
  '$filter',
  '$rootScope',
  'moment',
  'FlashService',
  'CONFIGURATIONS',
  'TIME_ZONES',
  'RestResource',
  'CropImageService',
  'ModalService',
  'ModalWindowConfirmService',
  'UploadService',
  'alertService', // Angular downgraded service
];

export function UtilServiceAjs(
  $translate,
  $filter,
  $rootScope,
  moment,
  FlashService,
  CONFIGURATIONS,
  TIME_ZONES,
  RestResource,
  CropImageService,
  ModalService,
  ModalWindowConfirmService,
  UploadService,
  alertService
) {
  $translate = $filter('translate');

  var ACTIVE = CONFIGURATIONS.ACTIVE;
  var INACTIVE = CONFIGURATIONS.INACTIVE;

  function UtilServiceAjs(scope) {
    this._scope = scope;
  }

  UtilServiceAjs.prototype.getProductTypes = function () {
    var productTypes = CONFIGURATIONS.PRODUCT_TYPES;

    productTypes.forEach(function (productType) {
      productType.name = $translate(productType.name);
    });

    return productTypes;
  };

  UtilServiceAjs.prototype.setProductType = function (product) {
    var productTypes = CONFIGURATIONS.ALL_PRODUCT_TYPES;

    var result;
    for (var i = 0; i < productTypes.length; i++) {
      if (productTypes[i].type === product.product_type) {
        productTypes[i].name = $translate(productTypes[i].name);
        result = productTypes[i];
        break;
      }
    }

    return result;
  };

  // Will be called when filtering the grid, will reset the page number to one
  UtilServiceAjs.prototype.filterResult = function () {
    var scope = this._scope;

    // delete scope.filterCriteria.offset; // To start from 0
    scope.filterCriteria.page = 1;
    if (scope.meta !== undefined) {
      scope.filterCriteria.offset = (scope.filterCriteria.page - 1) * scope.meta.itemsPerPage;
      scope.fetchResult();
    }
  };

  UtilServiceAjs.prototype.checkStatus = function (status) {
    if (status === 'inactive' || status === false) {
      return 'disabled';
    }
  };

  UtilServiceAjs.prototype.checkStatuses = function (statusList) {
    var count = 0;

    statusList.forEach(function (status) {
      if (status === 'inactive' || status === false) {
        count += 1;
      }
    });

    if (count > 0) {
      return 'disabled';
    }
  };

  // chekc input status based on async
  UtilServiceAjs.prototype.checkInputStatus = function (field) {
    var inputClass = '';

    if (field.$pending) {
      inputClass = 'input_pending';
    } else if (field.$valid) {
      inputClass = 'input_success';
    } else if (field.$invalid && field.$touched) {
      inputClass = 'input_error';
    }

    return inputClass;
  };

  // showActions = true on checkbox
  UtilServiceAjs.prototype.showActions = function () {
    var scope = this._scope;

    var count = 0;

    scope.items.forEach(function (item) {
      if (item.Selected) {
        count++;
      }
    });

    scope.showActions = count ? true : false;
    scope.totalItemsSelected = count;

    scope.selectedAll = false;
  };

  // Check/Uncheck checkboxes
  UtilServiceAjs.prototype.selectCheckBoxes = function (currentItemId) {
    var scope = this._scope;

    if (!scope.selectedAll) {
      scope.selectedAll = false;
    }

    var restCounter = 0;

    scope.items.forEach(function (item) {
      if (
        item.is_default ||
        item.predefined ||
        item.id === currentItemId ||
        // item.price_lists_in_use ||
        item.used_in_transactions
      ) {
        // Not evaluate hidden checkboxes
        restCounter = restCounter + 1;
      } else {
        item.Selected = scope.selectedAll;
      }
    });

    scope.showActions = scope.selectedAll ? true : false;

    scope.totalItemsSelected = scope.items.length - restCounter;
  };

  // Uncheck all checkboxes
  /* UtilServiceAjs.prototype.unselectCheckBoxes = function () {
    var scope = this._scope;

    scope.selectedAll = false;
    scope.items.forEach(function (item) {
      item.Selected = scope.selectedAll;
    });

    scope.showActions = false;
  }; */

  // Delete items
  UtilServiceAjs.prototype.deleteItems = function (successCallback) {
    var modalParams = {
      mode: 'danger',
      title: 'SURE_TO_DELETE_ITEMS',
      confirmButtonLabel: 'CONFIRM_DELETION',
    };

    ModalWindowConfirmService.open(modalParams, successCallback);
  };

  UtilServiceAjs.prototype.warningMsg = function (modalParams, successCallback, cancelCallback) {
    modalParams.mode = modalParams.mode || 'danger';
    modalParams.title = modalParams.title || 'WARNING';
    modalParams.body = modalParams.body || '';

    modalParams.preventModalClose = true;

    // modalParams.confirmButtonLabel = params.confirmButtonLabel || 'CONFIRM';

    ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
  };

  // Notify messages
  UtilServiceAjs.prototype._successMsg = function (msg) {
    alertService.open(msg);
  };

  UtilServiceAjs.prototype._errorMsg = function (msg) {
    // Alertify.error(msg);
    alertService.open(msg, 'error');
  };

  UtilServiceAjs.prototype._alertMsg = function (msg) {
    alertService.open(msg, 'error');
  };

  // Set flash message
  UtilServiceAjs.prototype._setFlashMessage = function (msg) {
    FlashService.setMessage(msg);
  };

  // Display flash message
  UtilServiceAjs.prototype._displayFlashMessage = function () {
    return FlashService.getMessage();
  };

  // Clear flash message
  UtilServiceAjs.prototype._clearFlashMessage = function () {
    return FlashService.clearMessage();
    //return '';
  };

  // Check input errors
  UtilServiceAjs.prototype.interacted = function (field) {
    var scope = this._scope;

    // if (field && field.$name && field.$name == 'cutoff_time_unit') {
    // console.log(field);
    // console.log(field.$name, field.$touched);
    // }

    var touched = field === undefined ? false : field.$touched;

    return scope.formErrors || touched; // Keep in touched // submitted
  };

  // Check input errors
  UtilServiceAjs.prototype.checkInputErrorClass = function (field) {
    var scope = this._scope;

    if (field !== undefined) {
      var inputClass = '';
      if ((scope.formErrors || field.$touched) && field.$invalid) {
        inputClass = 'has-error';
      }

      return inputClass;
    }
  };

  // Check input valid
  UtilServiceAjs.prototype.isInputInvalid = function (field) {
    var scope = this._scope;

    return (scope.submitted || field.$touched) && field.$invalid;
  };

  // Clean server error
  UtilServiceAjs.prototype.cleanInputErrors = function (field) {
    // not needed if is _showItemServerErrors
    var scope = this._scope;

    scope['serverError_' + field] = false;
  };

  // Show item server errors
  UtilServiceAjs.prototype._showItemServerErrors = function (errors) {
    var serverErrors = [];
    for (var field in errors) {
      if (errors.hasOwnProperty(field)) {
        var error = errors[field];
        serverErrors[field] = error.join(', ');
      }
    }
    return serverErrors;
  };

  // Clean input server error
  UtilServiceAjs.prototype.cleanInputServerError = function (field) {
    var scope = this._scope;

    if (scope.serverErrors !== undefined) {
      scope.serverErrors[field] = false;
    }
  };

  // Check if there are changes in the form values - so we can avoid server load
  UtilServiceAjs.prototype.isFormDataChanged = function (item, orginalItem, fieldsDefinition) {
    if (!item.id) {
      // Create
      return true;
    }

    var isDirty = false;

    fieldsDefinition.forEach(function (field) {
      // short circuit if item is dirty
      if (!isDirty && item[field] !== orginalItem[field]) {
        isDirty = true;
      }
    });

    return isDirty;
  };

  UtilServiceAjs.prototype.itemListChanged = function (id) {
    setTimeout(function () {
      var tr = document.getElementById(id);

      if (!tr) {
        return;
      }

      tr.className += ' changed';
      setTimeout(function () {
        tr.className = tr.className.replace('changed', 'restore');
      }, 1000);
    });
  };

  // Modal for image crop
  UtilServiceAjs.prototype.openLogo = function (item, saveLogoCallBack, width, height) {
    CropImageService.open(item, saveLogoCallBack, width, height);
  };

  // Save logo after crop
  UtilServiceAjs.prototype.updateLogo = function (url, model, item, cropedImage, successCallback) {
    if (cropedImage.fileName) {
      var util = UtilServiceAjs.prototype;

      return UploadService.uploadFile(
        'PUT',
        url,
        model,
        { id: item.id },
        cropedImage,
        function () {},
        function (response) {
          util._successMsg('PHOTO_UPDATED');

          // Image preview
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>

          img.src = URL.createObjectURL(cropedImage.file);

          if (successCallback) {
            successCallback(response);
          }
        },
        function () {
          util._errorMsg('ERROR_UPLOADING');
        }
      );
    }
  };

  // Load multiple selected objects to ui-select - Two models
  UtilServiceAjs.prototype.loadMultipleSelectedItems = function (ids, items) {
    var index,
      options = [];

    var util = UtilServiceAjs.prototype;

    if (ids != null) {
      ids.forEach(function (id) {
        index = util.findArrayIndex(items, 'id', id);

        if (index != null) {
          options.push(items[index]);
        }
      });
    }

    return options;
  };

  // Add multiple selected objects
  UtilServiceAjs.prototype.addMultipleSelectedItems = function (items) {
    var options = [];

    items.forEach(function (item) {
      options.push(item.id);
    });

    return options;
  };

  // Find and load object in MultiArray of objects - One model
  UtilServiceAjs.prototype.findObjectsInMultiArray = function (items, field, search) {
    var options = [];

    items.forEach(function (item, index) {
      if (item[field] != null) {
        for (var i = 0; i < item[field].length; i++) {
          var value = item[field][i];
          if (value === search) {
            options.push(items[index]);
            break;
          }
        }
      }
    });

    return options;
  };

  // Set duration time
  UtilServiceAjs.prototype.setDurationTime = function (duration) {
    var durationTime = new Date();
    var hours = 0,
      minutes = 0;

    if (duration) {
      var durationSplit = duration.split(':');
      hours = Number(durationSplit[0]);
      minutes = Number(durationSplit[1]);
    }

    // Convert to date
    durationTime.setHours(hours, minutes);

    // console.log(durationTime);
    return durationTime;
  };

  // Group zones by value
  UtilServiceAjs.prototype.groupTimeZonesByValue = function () {
    var timeZones = TIME_ZONES;

    var options = [];

    timeZones.forEach(function (data) {
      data.cities.forEach(function (city) {
        options.push({
          value: data.value,
          abbr: data.abbr,
          offset: data.offset,
          isdst: data.isdst,
          utc: data.utc,
          city: city,
        });
      });
    });

    return options;
  };

  // Validate unique items in array
  UtilServiceAjs.prototype.validateUniqueItems = function (items, field) {
    var duplicated = false;
    if (items.length > 1) {
      for (var i = 0; i < items.length; ++i) {
        for (var j = 0; j < items.length; ++j) {
          if (i !== j && items[i][field] && items[i][field] === items[j][field]) {
            duplicated = true;
            break;
          }
        }

        if (duplicated) {
          break;
        }
      }
    }
    return duplicated;
  };

  // UtilServiceAjs.prototype.testing = function () {
  //   console.log('TESTIING FROM UTILSERVICE');
  // };

  UtilServiceAjs.prototype.getItemsMetaData = function (response, filterCriteria) {
    var itemsPerPage = CONFIGURATIONS.ITEMS_PER_PAGE;
    var totalPages = Math.ceil(response.meta.itemsFound / itemsPerPage);

    var meta = {
      totalItems: response.meta.totalItems,
      itemsFound: response.meta.itemsFound,
      itemsPerPage: itemsPerPage,
      totalPages: totalPages,
      startItemNumber: 1,
      endItemNumber: 0,
    };

    if (filterCriteria.page > 1) {
      meta.startItemNumber = (filterCriteria.page - 1) * itemsPerPage + 1;
    }

    meta.endItemNumber = meta.startItemNumber + response.data.length - 1;

    return meta;
  };

  // Convert string data to array of buffer for save the xlsx file
  UtilServiceAjs.prototype.s2ab = function (str) {
    var s = atob(str);
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i);
    } // & 0xFF
    return buf;
  };

  UtilServiceAjs.prototype.startOfDayFormat = function (date) {
    return moment(date).startOf('day').toISOString();
  };

  UtilServiceAjs.prototype.endOfDayFormat = function (date) {
    return moment(date).endOf('day').toISOString();
  };

  // UTC
  UtilServiceAjs.prototype.startOfDayUTCFormat = function (date) {
    return moment(date).utc().startOf('day').toISOString();
  };

  // UTC
  UtilServiceAjs.prototype.endOfDayUTCFormat = function (date) {
    return moment(date).utc().endOf('day').toISOString();
  };

  UtilServiceAjs.prototype.currentDateUTCFormat = function (date) {
    var fullDate =
      moment(date).format(CONFIGURATIONS.DATE_FORMAT_DB) + ' ' + moment().format('HH:mm:ss');

    return moment(fullDate).utc().toISOString(); // 2018-04-06T17:32:37.000Z
    //return moment(fullDate).utc().format('YYYY-MM-DD HH:mm:ss'); // 2018-04-06 17:33:27
  };

  UtilServiceAjs.prototype.today = function () {
    return moment();
  };

  UtilServiceAjs.prototype.startOfMonth = function () {
    return moment().startOf('month');
  };

  UtilServiceAjs.prototype.websiteTabs = function (websiteId) {
    return [
      // { name: 'WEBSITE_DETAIL', icon: 'binoculars', url: 'websites/'+ websiteId },
      {
        name: 'TOURS',
        icon: 'binoculars',
        url: 'tour_contents?WSID=' + websiteId,
      },
      {
        name: 'TRANSPORTATION',
        icon: 'truck',
        url: 'transportation_contents?WSID=' + websiteId,
      },
      {
        name: 'HOTELS',
        icon: 'building',
        url: 'hotel_contents?WSID=' + websiteId,
      },
      {
        name: 'PACKAGES',
        icon: 'suitcase',
        url: 'package_contents?WSID=' + websiteId,
      },
    ];
  };

  UtilServiceAjs.prototype.placesTabs = function () {
    return [
      { name: 'COUNTRIES', url: 'countries' },
      { name: 'LOCATIONS', url: 'locations' },
      { name: 'ZONES', url: 'zones' },
      { name: 'PICKUP_PLACES', url: 'pickup_places' },
    ];
  };

  // To avoid image chache issues
  UtilServiceAjs.prototype.cleanItemsCache = function (items, field) {
    var random = new Date().toString();

    items.forEach(function (item) {
      if (item[field] && item[field]['url']) {
        item.logoUrl = item[field]['url'] + '?cb=' + random;
      }
    });

    return items;
  };

  // To avoid image chache issues
  UtilServiceAjs.prototype.cleanItemCache = function (item, field) {
    var random = new Date().toString();

    var image = item[field] && item[field]['url'] ? item[field]['url'] + '?cb=' + random : ''; // assets/img/default_logo.jpg

    return image;
  };

  // Round to n decimal places (only if necessary)
  UtilServiceAjs.prototype.roundNum = function (number, decimals) {
    number = isNaN(number) ? 0 : number;
    decimals = decimals || 2;

    // console.log(typeof(number))

    // return Number(Math.round(number + 'e' + decimals) + 'e-' + decimals); // 2300.8856 roun to 2300.89

    const factor = 10 ** decimals;
    return Math.round(number * factor) / factor; // https://www.codegrepper.com/code-examples/typescript/math+round+to+3+digits

    // var newnumber = new Number(number+'').toFixed(parseInt(4));
    // return parseFloat(newnumber);

    // number = number ? (number*1).toFixed(2) : 0.00;
    // return parseFloat(number);

    // return Math.round((number + Number.EPSILON) * 100) / 100;

    // return parseFloat(Math.round(Number(number) * 100) / 100).toFixed(2); // not working to fixed

    // return parseFloat(number); // keep all values

    // let multiplier = Number(10 ** (decimals)); // parseInt(10 ** (decimals)); // 10, 100, 1000  Math.pow(10, decimals)
    // return parseFloat(Math.round((number + Number.EPSILON) * multiplier) / multiplier);

    // replace .00 to '' - not needed at the replace is for the view
    // var numSign = number >= 0 ? 1 : -1;
    // return ( Math.round( (number * multiplier) + (numSign * 0.0001) ) / multiplier ).toFixed(decimals).replace(/\.00$/,'');

    // return +(Math.round(number * multiplier) / multiplier).toFixed(decimals).replace(/\.00$/,''); // .5 -> .50

    // var pair = (number + 'e').split('e');
    // var value = Math.round(pair[0] + 'e' + (+pair[1] + decimals));
    // pair = (value + 'e').split('e');
    // return +(pair[0] + 'e' + (+pair[1] - decimals));

    // return +(Math.round(number + 'e+'+ decimals) + 'e-'+ decimals);
  };

  // fix to n decimales only if necessary
  /*UtilServiceAjs.prototype.currencyFormat = function (amount, decimals) {
            decimals = decimals || 2;

            return amount.toFixed(decimals).replace(/\.?0*$/g,'');
        };*/

  UtilServiceAjs.prototype.embedYouTubeVideo = function (video) {
    return video ? video.replace('watch?v=', 'embed/') : '';
  };

  UtilServiceAjs.prototype.scrollToTop = function (to) {
    var goTo = to ? '#' + to + ' .modal-body' : 'html, body';

    $(goTo).animate({ scrollTop: 0 }, 'slow');
    return false;
  };

  UtilServiceAjs.prototype.getLowestItemValueFromArray = function (array, field) {
    var item = array[0]; // First element from the array
    for (var i = 0; i < array.length; i++) {
      if (array[i][field] && array[i][field] < item[field]) {
        item = array[i];
      }
    }

    return item;
  };

  UtilServiceAjs.prototype.getHighestItemValueFromArray = function (array, field) {
    var item = array[0]; // First element from the array
    for (var i = 0; i < array.length; i++) {
      if (array[i][field] && array[i][field] > item[field]) {
        item = array[i];
      }
    }

    return item;
  };

  // Find index of an array
  UtilServiceAjs.prototype.findArrayIndex = function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return i;
      }
    }

    return null;
  };

  UtilServiceAjs.prototype.findItemInArray = function (array, key, value) {
    if (!array) {
      return null;
    }

    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }

    return null;
  };

  UtilServiceAjs.prototype.removeItemFromArray = function (array, key, value) {
    var util = UtilServiceAjs.prototype;

    var index = util.findArrayIndex(array, key, value);
    array.splice(index, 1);

    return array;
  };

  // Get available items in two arrays, based in key/value
  UtilServiceAjs.prototype.getAvailableItemsInTwoArrays = function (array1, array2, key) {
    var util = UtilServiceAjs.prototype;

    function getAvailableItemsInTwoArraysByDifferentKeys(array1, array2, key1, key2) {
      var array = [],
        item_1,
        item_2,
        found;

      for (var i = 0; i < array1.length; i++) {
        item_1 = array1[i];
        found = false;
        for (var j = 0; j < array2.length; j++) {
          item_2 = array2[j];

          if (item_1[key1] === item_2[key2]) {
            // Found in second array
            found = true;
            break;
          }
        }

        if (!found) {
          array.push(item_1);
        }
      }

      return array;
    }

    return getAvailableItemsInTwoArraysByDifferentKeys(array1, array2, key, key);
  };

  UtilServiceAjs.prototype.reorderArrayStartingAt = function (array, index) {
    // slice(index, n_removed, items)

    // array = [1,2,3,4,5]
    // index = 2 (=>3)

    let start = array.slice(index); // This will return the elements from a given index   = [3,4,5]
    let end = array.slice(0, index); // This will return the elements before a given index = [1,2]

    return [...start, ...end]; // Concat 2nd array to first and return the result = [3,4,5,1,2]

    // return start.concat(end);
    // return array.slice(index).concat(array.slice(0, index)); // short method
  };

  // Remove key from array or object: Ex array['key']:[{ item: va l}] / key:{ item: va l}
  UtilServiceAjs.prototype.removeKeyFromArrayObject = function (array) {
    var obj = Object.keys(array).map(function (key) {
      return array[key];
    });

    return obj;
  };

  // Change item status
  UtilServiceAjs.prototype.changeItemStatus = function (apiUrl, item, params, successCallback) {
    if (!params) {
      params = {};
    }

    var confirmCallback = function () {
      var newStatus;
      if (typeof item.status === 'string') {
        newStatus = item.status === ACTIVE ? INACTIVE : ACTIVE;
      } else {
        // Boolean
        newStatus = !item.status;
      }

      var util = UtilServiceAjs.prototype;
      return RestResource.request(
        'put',
        apiUrl,
        { status: newStatus },
        function (response) {
          item.status = newStatus;

          if (params.successMsg) {
            util._successMsg(params.successMsg);
          }

          if (successCallback) {
            successCallback(response);
          }
        },
        function (response) {
          util._errorMsg(response.data.error);
          // util.openModalError(response.data.error); // Use a different title
        }
      );
    };

    if (item.status !== 'inactive' && item.status) {
      var modalParams = {
        mode: params.mode || 'danger',
        title: params.title || 'SURE_TO_DEACTIVATE_ITEM',
        body: params.body || '',
        requireConfirmation: params.requireConfirmation || false,
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    } else {
      return confirmCallback();
    }
  };

  // Change item featured
  UtilServiceAjs.prototype.changeItemFeatured = function (apiUrl, item) {
    item.featured = !item.featured; // Change and refresh at once

    return RestResource.request(
      'put',
      apiUrl,
      { featured: item.featured },
      function () {
        if (item.featured) {
          var util = UtilServiceAjs.prototype;

          util._successMsg('ADDED_TO_FEATURED_ITEMS');
        }
      },
      function () {}
    );
  };

  // Change item published
  UtilServiceAjs.prototype.changeItemPublished = function (apiUrl, item) {
    var newPublished = !item.published;

    var util = UtilServiceAjs.prototype;
    return RestResource.request(
      'put',
      apiUrl,
      { published: newPublished },
      function () {
        item.published = newPublished;

        var msg = item.published ? 'PUBLISHED' : 'UNPUBLISHED';
        util._successMsg(msg);
      },
      function (response) {
        util._errorMsg(response.data.error);
        // util.openModalError(response.data.error); // Use a different title
      }
    );
  };

  // Update multiple items
  UtilServiceAjs.prototype.updateItems = function (
    apiUrl,
    action,
    items,
    successCallback,
    params,
    reloadCompaniesSelector
  ) {
    var confirmCallback = function () {
      var util = UtilServiceAjs.prototype;

      var itemsChecked = [];

      items.forEach(function (item) {
        if (item.Selected) {
          itemsChecked.push(item.id);

          if (action !== 'destroy') {
            if (typeof item.status === 'string') {
              if (item.status === ACTIVE) {
                item.status = action === 'activate' ? ACTIVE : INACTIVE;
              } else {
                item.status = action === 'deactivate' ? INACTIVE : ACTIVE;
              }
            } else {
              item.status = !item.status;
            }
          }

          item.Selected = false;
        }
      });

      var dataParams = {
        option: action,
        ids: itemsChecked,
      };

      return RestResource.request(
        'put',
        apiUrl + '/update_items',
        dataParams,
        function () {
          if (action === 'destroy') {
            util._successMsg('DELETED_ITEMS');

            // successCallback();
          } else if (action === 'ping') {
            util._successMsg('MODIFIED_BOOKINGS');

            // successCallback();
          }

          successCallback();

          if (reloadCompaniesSelector) {
            // only for companyService
            // Reload company-selector-component
            $rootScope.$broadcast('reloadCompaniesSelector');
          }
        },
        function () {}
      );
    };

    var count = 0;

    items.forEach(function (item) {
      if (item.Selected) {
        count++;
      }
    });

    if (count === 0) {
      this._alertMsg('REQUIRED_ONE_ITEM');
    } else {
      var modalParams;
      if (action === 'destroy') {
        // Destroy
        modalParams = {
          mode: 'danger',
          title: 'SURE_TO_DELETE_ITEMS',
          reason: 'DELETE_ITEMS_REASON',
          confirmButtonLabel: 'CONFIRM_DELETION',
        };

        if (params) {
          modalParams.body = params.body || '';
        }

        ModalWindowConfirmService.open(modalParams, confirmCallback);
      } else {
        // Update
        if (action === 'deactivate') {
          modalParams = {
            mode: 'danger',
            title: 'SURE_TO_DEACTIVATE_ITEMS',
          };

          if (params) {
            modalParams.body = params.body || '';
          }

          ModalWindowConfirmService.open(modalParams, confirmCallback);
        } else {
          return confirmCallback();
        }
      }
    }
  };

  // Delete item - without API response
  UtilServiceAjs.prototype.deleteItem = function (url, successCallback, params, index) {
    if (!params) {
      params = {};
    }

    var modalParams = {
      mode: 'danger',
      title: params.title || 'SURE_TO_DELETE_ITEM',
      itemName: params.itemName || '',
      body: params.body || '',
      reason: params.reason || '',
      requireConfirmation: params.requireConfirmation || false,
      confirmButtonLabel: params.confirmButtonLabel || 'CONFIRM_DELETION',
    };

    var successMsg = params.successMsg || 'DELETED_ITEM';

    var confirmCallback = function (reasonStatus) {
      var util = UtilServiceAjs.prototype;
      var item = { reason_status: reasonStatus, company_id: '' };

      if (params.company_id) {
        item.company_id = params.company_id;
      }

      function success() {
        util._successMsg(successMsg);

        return successCallback(index);
      }
      function failure(response) {
        util._errorMsg(response.data.error);
        // util.openModalError(response.data.error); // Use a different title
      }

      return RestResource.request('delete', url, item, success, failure);
    };

    ModalWindowConfirmService.open(modalParams, confirmCallback);
  };

  UtilServiceAjs.prototype.generateURL = function (item, editMode, generate = false) {
    let newURL = '';

    if (item.name !== undefined && (!editMode || generate)) {
      const replaceExp = new RegExp('[^0-9a-zA-Z]', 'g');

      newURL = item.name.trim().replace(replaceExp, '-').toLowerCase();
      item.url = newURL.replace(/(-)\1+/g, '$1');
    } else if (item.name === undefined && !item.id) {
      item.url = '';
    }

    return item.url;
  };

  UtilServiceAjs.prototype.openProductsChangeUrlModal = function (successCallback) {
    const preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    // let result = '';
    ModalService.showModal({
      templateUrl: './app/ajs/tour-contents/modals/tour-change-url-modal.html', // TODO: why this template ??
      controller: [
        '$element',
        function ($element) {
          this.generatedNewUrl = function (result) {
            $element.modal('hide');
            successCallback(result);

            return result;
          };
        },
      ],
      controllerAs: 'vm',
    }).then(function (modal) {
      modal.element.modal(preventModalClose);
    });
  };

  UtilServiceAjs.prototype.openModalError = function (msg) {
    let modalParams = {
      mode: 'danger',
      title: 'ACTION_NOT_ALLOWED',
      body: msg,
      closeButtonLabel: 'ACCEPT',
    };

    ModalWindowConfirmService.open(modalParams);
  };

  UtilServiceAjs.prototype.datePickerOptions = function (options) {
    let filterBy = options.filterBy;
    let rangeOptions = options.rangeOptions;
    let dateDisplay = options.dateDisplay || CONFIGURATIONS.DATE_DISPLAY_SHORT;
    let minDate = options.minDate;
    let maxDate = options.maxDate;
    let opens = options.opens;

    var dateRanges = {};

    if (rangeOptions.up_to_date) {
      dateRanges[$translate('UP_TO_DATE')] = [options.startDate, moment()];
    }

    if (rangeOptions.today) {
      dateRanges[$translate('TODAY')] = [moment(), moment()];
    }

    if (rangeOptions.yesterday) {
      dateRanges[$translate('YESTERDAY')] = [
        moment().subtract(1, 'days'),
        moment().subtract(1, 'days'),
      ];
    }

    // if (rangeOptions.last_7_days){
    //     dateRanges[$translate('LAST_7_DAYS')] = [moment().subtract(6, 'days'), moment()];
    // }

    if (rangeOptions.this_week) {
      dateRanges[$translate('THIS_WEEK')] = [moment().startOf('week'), moment().endOf('week')];
    }

    if (rangeOptions.last_week) {
      dateRanges[$translate('LAST_WEEK')] = [moment().subtract(6, 'days'), moment()];
    }

    // if (rangeOptions.last_30_days){
    //     dateRanges[$translate('LAST_30_DAYS')] = [moment().subtract(29, 'days'), moment()];
    // }

    if (rangeOptions.this_month) {
      dateRanges[$translate('THIS_MONTH')] = [moment().startOf('month'), moment().endOf('month')];
    }

    if (rangeOptions.last_month) {
      dateRanges[$translate('LAST_MONTH')] = [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ];
    }

    if (rangeOptions.next_month) {
      dateRanges[$translate('NEXT_MONTH')] = [
        moment().add(1, 'months').startOf('month'),
        moment().add(1, 'months').endOf('month'),
      ];
    }

    let datePickerOpts = {
      showCustomRangeLabel: false,
      alwaysShowCalendars: true,
      showDropdowns: true,
      autoApply: true,
      // cancelButtonClasses: 'btn-hide-css-whatever',
      locale: {
        format: dateDisplay,
        applyLabel: $translate('SELECT'),
        cancelLabel: $translate('CLEAR'),
        customRangeLabel: $translate('CUSTOM_RANGE'),
      },
      ranges: dateRanges,
      eventHandlers: {
        'apply.daterangepicker': function applyDateRangePicker() {
          filterBy('apply');
        },
        // 'cancel.daterangepicker': function cancelDateRangePicker() {
        //     filterBy('cancel');
        // }
      },
      opens: false,
      minDate: false,
      maxDate: false,
    };

    if (rangeOptions.custom_range) {
      datePickerOpts.showCustomRangeLabel = true;
    }

    if (opens) {
      datePickerOpts.opens = opens;
    }

    if (minDate) {
      datePickerOpts.minDate = minDate;
    }

    if (maxDate) {
      datePickerOpts.maxDate = maxDate;
    }

    return datePickerOpts;
  };

  UtilServiceAjs.prototype.singleDatePickerOptions = function (options) {
    let minDate = options.minDate;
    let maxDate = options.maxDate;
    let showDropdowns = options.showDropdowns;
    let onChangeDate = options.onChangeDate;

    let datePickerOpts = {
      singleDatePicker: true,
      locale: {
        format: options.dateDisplay,
      },
      eventHandlers: {
        'apply.daterangepicker': function () {
          // changeDate
          if (onChangeDate) onChangeDate();
        },
      },
      minDate: false,
      maxDate: false,
      showDropdowns: false,
    };

    if (minDate) {
      datePickerOpts.minDate = minDate;
    }

    if (maxDate) {
      datePickerOpts.maxDate = maxDate;
    }

    if (showDropdowns) {
      datePickerOpts.showDropdowns = showDropdowns;
    }

    return datePickerOpts;
  };

  UtilServiceAjs.prototype.validatePattern = function (element, pattern) {
    var ALLOW_PATTERN;

    switch (pattern) {
      case 'alpha':
        ALLOW_PATTERN = /^[a-z\s]+$/;
        break;
      case 'numbers':
        ALLOW_PATTERN = /^[\d\s]+$/;
        break;
      case 'alphanumeric':
        ALLOW_PATTERN = /^[a-z\d\s]+$/;
        break;
      case 'phone':
        ALLOW_PATTERN = /^[\d- ]+$/; // numbers and - and spaces
        break;
      case 'currency':
        ALLOW_PATTERN = /^[\d.]+$/; // numbers and .
        break;
      case 'map':
        ALLOW_PATTERN = /^[\d.-]+$/;
        break;
      case 'email':
        ALLOW_PATTERN = /^[a-z\@\d._-]+$/;
        break;
      case 'text':
        ALLOW_PATTERN =
          /^[a-zA-Z0-9\Á\á\É\é\Í\í\Ó\ó\Ú\ú\Ñ\ñ\_\=\+\-\*\'\"\?\¿\!\¡\.\:\,\#\$\&\/\(\)\ ]*$/;
        break;
      default:
        ALLOW_PATTERN = pattern;
        break;
    }

    // I handle key events
    element.bind('keypress', function (event) {
      var keyCode = event.which || event.keyCode; // I safely get the keyCode pressed from the event.
      var keyCodeChar = String.fromCharCode(keyCode); // I determine the char from the keyCode.

      // If the keyCode char does not match the allowed Regex Pattern, then don't allow the input into the field.
      if (!keyCodeChar.match(new RegExp(ALLOW_PATTERN, 'i'))) {
        event.preventDefault();
        return false;
      }
    });
  };

  UtilServiceAjs.prototype.deleteEmptyFields = function (fields, params) {
    fields.forEach((field) => {
      if (!params[field]) {
        delete params[field];
      }
    });

    return params;
  };

  return UtilServiceAjs;
}
